import React from "react"
import { useSelector } from "react-redux"


export default function TwoFaVerify() {
    const { app } = useSelector(state => state.appReducer)

    React.useEffect(() => {
        if(app.id && !app.phone) {
            localStorage.setItem('data-bs-2fa', false)
        }
        
        if(app.id && app.phone) {
            localStorage.setItem('data-bs-2fa', true)
        }
    }, [app])

    return (
        <>
        </>
    )
}
